import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Llevaba años llamando al electricista hasta para cambiar un enchufe. Con el Tomo 2 lo hice yo solo en 20 minutos. Mi mujer no se lo creía. Esta semana ya cambié 4 enchufes y 2 interruptores. El libro se pagó solo en el primer día.',
    initials: 'JM',
    name: 'José Manuel R.',
    age: '48 años',
    role: 'Propietario',
    city: 'Sevilla',
    time: 'hace 2 semanas'
  }, {
    quote: 'Tenía un ventilador de techo en la caja desde hace 3 meses porque no sabía instalarlo. Con el Tomo 3 lo hice sola un sábado por la mañana. Tardé 50 minutos. El electricista me había pedido 90€. Lo hice por 0€.',
    initials: 'ML',
    name: 'María Luisa P.',
    age: '41 años',
    role: 'Madre de familia',
    city: 'Valencia',
    time: 'hace 1 mes'
  }, {
    quote: 'El diferencial me saltaba cada dos por tres y el técnico me cobró 80€ para decirme que era la lavadora. Con el Kit de Emergencia yo mismo lo hubiera diagnosticado en 10 minutos. Ahora ya sé hacerlo. Muy recomendable.',
    initials: 'AR',
    name: 'Antonio R.',
    age: '55 años',
    role: 'Jubilado',
    city: 'Zaragoza',
    time: 'hace 3 semanas'
  }, {
    quote: 'Compré la colección para ahorrar y terminé ganando dinero extra. En el primer mes ya recuperé la inversión haciendo trabajitos para vecinos. El Tomo 4 es oro puro. Ya tengo 3 clientes fijos los fines de semana.',
    initials: 'DC',
    name: 'David C.',
    age: '37 años',
    role: 'Empleado con ingresos extra',
    city: 'Madrid',
    time: 'hace 5 días'
  }];
  return <section className="w-full bg-gray-50 py-20 px-4 border-t border-gray-200" data-id="element-261">
      <div className="max-w-6xl mx-auto" data-id="element-262">
        <div className="text-center mb-16" data-id="element-263">
          <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-264">
            Lo que dicen quienes ya lo tienen
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mt-6 leading-tight" data-id="element-265">
            Personas Reales. Resultados Reales.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-266">
          {testimonials.map((t, idx) => <div key={idx} className="bg-white p-6 md:p-8 rounded-xl shadow-md border-t-4 border-blue-600 flex flex-col h-full" data-id="element-267">
              <div className="flex gap-1 mb-4" data-id="element-268">
                {[...Array(5)].map((_, i) => <Star key={i} className="text-yellow-400 fill-yellow-400" size={20} data-id="element-269" />)}
              </div>

              <p className="text-gray-700 font-medium text-lg italic mb-6 flex-grow" data-id="element-270">
                "{t.quote}"
              </p>

              <div className="flex items-center gap-4 mt-auto pt-4 border-t border-gray-100" data-id="element-271">
                <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center text-gray-600 font-bold text-lg shrink-0" data-id="element-272">
                  {t.initials}
                </div>
                <div data-id="element-273">
                  <div className="font-bold text-gray-900" data-id="element-274">{t.name}</div>
                  <div className="text-sm text-gray-500" data-id="element-275">
                    {t.age} • {t.role} • {t.city} • {t.time}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}